import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import CommonModal from "./CommonModal";
import { fundedInvoicesData } from "../../locales/en";
import Style from "./modal.module.scss";

const CurrentOutStanding = ({
  isOpen,
  toggle,
  setActiveTab,
  toggleOutStanding
}) => {
  const handleLinkClick = (e) => {
    e.preventDefault();
    setActiveTab("2");
    toggleOutStanding();
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <CommonModal
      isOpen={isOpen}
      toggle={toggle}
      title=""
      modalClassName={`${Style.xeroModal} modal-dialog-centered modal-md`}
      headerClassName={Style.creditModalHeader}
      bodyClassName={`${Style.manualUploadContent} modal-content border-0 text-center`}
      hideFooter
    >
      <div className="inv-upload-template d-flex flex-sm-wrap-reverse">
        <p>
          {fundedInvoicesData?.CurrentOutStanding?.subtitle}
          <Link to="" onClick={handleLinkClick}>
            {fundedInvoicesData?.funded?.fundedNav}
          </Link>
          {fundedInvoicesData?.CurrentOutStanding?.subtitle2}
        </p>
      </div>
    </CommonModal>
  );
};

CurrentOutStanding.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  setActiveTab: PropTypes.func.isRequired,
  toggleOutStanding: PropTypes.func.isRequired
};

export default CurrentOutStanding;
